/** 仅将后端根路径资源转为同源代理地址；外站、对象 URL 和已有代理前缀保持原样。 */
export function resolveHttpResourceUrl(value: string): string {
  if (!value.startsWith("/") || /^\/[\\/]/.test(value) || /^\/api(?:[/?#]|$)/.test(value)) return value;
  return `/api${value}`;
}
